import React, { createContext } from 'react';
import { useGetInfo } from '~/apis/auth';
import { AuthProtocolGetInfoResponse } from '~/swagger/data-contracts';

export const AppContext = createContext<Omit<AuthProtocolGetInfoResponse, 'userId'>>({} as AuthProtocolGetInfoResponse);

const AppContextProvider = ({ children }: React.PropsWithChildren<Record<never, any>>): JSX.Element => {
  const { data: userInfo } = useGetInfo();

  return (
    <AppContext.Provider
      value={{
        clientId: userInfo?.clientId || 0,
        userEmail: userInfo?.userEmail || '',
        clientName: userInfo?.clientName || '',
        googleConfirmNeeded: userInfo?.googleConfirmNeeded || false,
        confirmNeeded: userInfo?.confirmNeeded || false,
        createdDate: userInfo?.createdDate || '',
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
